import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';

const nkCookieName = '.NK_COOKIE';

const get = () => Cookies.get(nkCookieName);

const nkCookieExists = () => Cookies.get(nkCookieName) !== undefined;

const set = cookieData => {
  Cookies.set(nkCookieName, cookieData);
};

const remove = () => {
  Cookies.remove(nkCookieName);
};

const getCookie = name => Cookies.get(name);

const cookieExists = name => getCookie(name) !== undefined;

const getLangFromCookie = () => {
  if (!cookieExists(nkCookieName)) return null;
  const cookie = getCookie(nkCookieName);
  const jwt = jwtDecode(cookie);
  return jwt.locale;
};

const getUserData = () => {
  if (!cookieExists(nkCookieName)) return null;
  const cookie = getCookie(nkCookieName);
  return jwtDecode(cookie);
};

const cookieIsFresh = () => {
  const decoded = jwtDecode(getCookie(nkCookieName));
  const now = Date.now().valueOf() / 1000;
  if (!decoded.exp || decoded.exp <= now) {
    return false;
  }
  return true;
};

const isCookieValid = () => nkCookieExists() && cookieIsFresh();

const getPermissionFeaturesFromCookie = () =>
  cookieExists(nkCookieName)
    ? jwtDecode(getCookie(nkCookieName)).PermissionFeatures
    : [];

const getPermissionActionsFromCookie = () =>
  cookieExists(nkCookieName)
    ? jwtDecode(getCookie(nkCookieName)).PermissionActions
    : [];

const cookieHasPermissionFeature = feature => {
  const features = getPermissionFeaturesFromCookie();
  return features !== undefined && features.includes(feature);
};

const cookieHasPermissionAction = action => {
  const actions = getPermissionActionsFromCookie();
  return actions !== undefined && actions.includes(action);
};

const hasPermission = feature => cookieHasPermissionFeature(feature);

const hasAction = action => cookieHasPermissionAction(action);

const isAllowed = actionName =>
  isCookieValid() && hasPermission('AccountingV2') && hasAction(actionName);

const authCookie = {
  get,
  getLangFromCookie,
  getUserData,
  nkCookieExists,
  set,
  remove,
  isAllowed,
};

export default authCookie;
